// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__DiS-L","choiceBoxes":"toolbarselects_choiceBoxes__2_ONu","simpleField":"toolbarselects_simpleField__1yjTW"};